import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  wrapHeaderTitle: {
    display: "flex",
    justifyContent: "space-between",
    marginBottom:"10px"
  },
  tab: {
    fontSize: "13px",
    "@media (max-width: 480px)": {
      fontSize: "11px",
    },
  },
  belumBayar: {
    display: "flex",
    alignItems: "center",
  },
  innerRow: {
    margin: "0 0 10px 0",
  },
  wrapPaper: {
    padding: "20px",
    borderRadius: "10px",
  },
  timelineStatus: {
    width: "100%",
    overflow: "hidden",
    display: "flex",
    flexFlow: "row nowrap",
    justifyContent: "space-between",
    alignItems: "center",
    position: "relative",
    zIndex: 2,
    margin: "0 0 30px 0",
  },
  orderColTopLeft: {
    width: "45%",
    "@media (max-width: 768px)": {
      width: "100%",
    },
    "@media (max-width: 480px)": {
      width: "115%",
    },
  },
  timelineBox: {
    width: "25%",
    position: "relative",
  },
  checkpoint: {
    width: 50,
    height: 50,
    backgroundColor: theme.palette.textColor.white,
    border: "solid 5px " + theme.palette.textColor.gray2,
    borderRadius: "50%",
    color: theme.palette.textColor.primeTextColor,
    zIndex: 2,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "&::before": {
      backgroundColor: theme.palette.textColor.white,
      border: "solid 5px " + theme.palette.textColor.gray2,
      width: 120,
      height: 5,
      display: "block",
      content: '""',
      position: "absolute",
      top: 23,
      left: -90,
      zIndex: -2,
    },
  },
  active: {
    border: "solid 5px " + theme.palette.primary.main,
    backgroundColor: theme.palette.primary.main,
    color: "#fff",
    "&::before": {
      backgroundColor: theme.palette.primary.main,
      border: "solid 5px " + theme.palette.primary.main,
      width: 120,
      height: 5,
      display: "block",
      content: '""',
      position: "absolute",
      top: 23,
      left: -90,
      zIndex: -1,
    },
  },
  wrapImage: {
    width: "40%",
  },
  image: {
    width: 100,
    height: 100,
  },
  wrapCountdown: {
    display: "flex",
    paddingBottom: "20px",
    alignItems: "center",
    paddingTop: "20px",
  },
  wrapTotalPembayaran: {
    display: "flex",
    justifyContent: "space-between",
  },
  totalPembayaran: {
    display: "flex",
  },
  wrapAlamat: {
    display: "flex",
    justifyContent: "space-between",
  },
  wrapBelilagi: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  liquidPrimary: {
    fontSize: 13,
    "@media (max-width: 480px)": {
      maxWidth: "100px",
      fontSize: 11,
    },
  },
  liquidBold: {
    fontSize: 13,
    fontWeight: "bold",
    "@media (max-width: 480px)": {
      fontSize: 11,
    },
  },
  liquidSecondList: {
    fontSize: 12,
    color: theme.palette.textColor.gray,
    "@media (max-width: 768px)": {
      maxWidth: "120px",
    },
    "@media (max-width: 480px)": {
      maxWidth: "100px",
    },
  },
  liquidSecond: {
    fontSize: 12,
    color: theme.palette.textColor.gray,
  },
  emptyCart: {
    display: "flex",
    textAlign: "center",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "calc(100vh - 60px)",
    paddingLeft: 30,
    paddingRight: 30,
  },
  emptyCartTitle: {
    fontWeight: 600,
  },
  btnCounter: {
    height: 24,
    marginLeft: 4,
    display: "flex",
  },
}));

export default useStyles;
